import COUNTRIES from '@/assets/countries.json'

export type Language = 'fr' | 'en' | 'es'

export type Country = {
  // translations
  fr_name: string
  es_name: string
  en_name: string

  iso_alpha_2: string
  iso_alpha_3: string
  phone_code: string
  flag: string
  eu?: boolean
}

const CountriesDB = COUNTRIES as Array<Country>
if (typeof window === 'undefined') {
  console.log(COUNTRIES.length, 'countries loaded')
}

// ------------------------------------------>

/**
 * Retursn all countries
 */
export const allCountries = () => CountriesDB.slice()

/**
 * Find a country by ISO code
 * @param code the string
 * @returns the country found
 */
export function findCountryByISO2(code: string): Country | undefined {
  return CountriesDB.find((c) => c.iso_alpha_2 === code)
}

/**
 * Find a country by ISO code
 * @param code the string
 * @returns the country found
 */
export function findCountryByISO3(code: string): Country | undefined {
  return CountriesDB.find((c) => c.iso_alpha_3 === code)
}

/**
 * Get every countries in the UE
 * @returns the list of countries
 */
export function getEUCountries(): Array<Country> {
  return CountriesDB.filter((c) => c.eu === true)
}

/**
 * Returns the name of the given country
 * @param country the country
 * @param language the language
 * @param defaultLanguage the default language
 * @returns the name translated into the given language (or the default language)
 */
export function getNameOf(
  country: Country,
  language: Language,
  defaultLanguage: Language = 'fr'
): string {
  return (
    country[`${language}_name`] ??
    country[`${defaultLanguage}_name`] ??
    country.fr_name
  )
}
